<template>
  <header>
    <v-app-bar
      app
      color="green"
      clipped-left
    >
      <v-app-bar-nav-icon @click="drawer = true" color='white'></v-app-bar-nav-icon>
      <v-toolbar-title >松尾中学校閉校記念HP</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tabs>
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab
          v-for="(menuItem, index) in menuItems"
          :key="index"
          :to="menuItem.url"
          style="color:white;"
        >{{ menuItem.name }}</v-tab>
      </v-tabs>
    </v-app-bar>
    <v-navigation-drawer
      v-model ='drawer'
      fixed
      temporary
      color="green"
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group>
          <v-list-item
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :to='menuItem.url'
          >
            <v-list-item-title style="font-size:15px; color:white;">{{ menuItem.name }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </header>
</template>

<script>
import constants from '../common/constants'

export default {
  name: 'Appheader',
  data() {
    return {
      drawer: false,
      menuItems: constants.menuItems
    }
  },
  // methods: {
  //   scrollTop() {
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "instant"
  //     })
  //   }
  // }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.scss";

.v-toolbar__title {
  overflow: visible !important;
  margin-right: 50px !important;
  color: white;
}
.v-app-bar__nav-icon {
  @include display_pc {
    display: none !important;
  }
}
.v-tabs {
  display: none;
  @include display_pc {
    display: block !important;
  }
}
.v-tab {
  color: white;
}
</style>
